import {
    IMappingProfile,
    IQueryParams,
    IQueryParamsSymbol,
    PFWmsEntities,
} from '@pf/shared-common';
import { createMap, forMember, mapFrom, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMetadata,
    withMetadata,
    withSearchFilter,
} from '@pf/shared-utility';
import {
    ReceiptLineCreate,
    ReceiptLineDto,
    ReceiptLineRead,
    ReceiptLineSearchParams,
} from '../../entities/receipt-line.dto';
import {
    CurrencySymbol,
    CustomFieldMetadataMap,
} from '@pf/shared/util-platform';

const symbols = entitySymbols(PFWmsEntities.ReceiptLine);

withDefaultEntityMetadata<ReceiptLineDto>(symbols.dto, {
    actualQuantity: Number,
    costPerUnit: CurrencySymbol,
    customFields: [CustomFieldMetadataMap.symbols.dto],
    damagedQuantity: Number,
    expectedQuantity: Number,
    externalReferenceId: String,
    inventoryReceipt: Object,
    inventoryReceiptId: String,
    isReceived: Boolean,
    item: Object,
    itemSerialNumber: String,
    lineNumber: String,
    modifiedByUser: String,
    purchaseOrderHeader: Object,
    purchaseOrderLine: Object,
    receivedBundle: Object,
    status: String,
    vendorLPN: String,
    advanceShippingNoticeId: String,
    advanceShippingNoticeLineId: String,
});

withDefaultEntityMetadata<ReceiptLineRead>(symbols.entity, {
    actualQuantity: Number,
    costPerUnit: CurrencySymbol,
    customFields: [CustomFieldMetadataMap.symbols.entity],
    damagedQuantity: Number,
    expectedQuantity: Number,
    externalReferenceId: String,
    inventoryReceipt: Object,
    inventoryReceiptId: String,
    isReceived: Boolean,
    item: Object,
    itemSerialNumber: String,
    lineNumber: String,
    modifiedByUser: String,
    purchaseOrderHeader: Object,
    purchaseOrderLine: Object,
    receivedBundle: Object,
    status: String,
    vendorLPN: String,
    advanceShippingNoticeId: String,
    advanceShippingNoticeLineId: String,
});

withMetadata<ReceiptLineCreate>(symbols.createBody, {
    actualQuantity: Number,
    costPerUnit: CurrencySymbol,
    damagedQuantity: Number,
    expectedQuantity: Number,
    externalReferenceId: String,
    isReceived: Boolean,
    itemId: String,
    itemSerialNumber: String,
    lineNumber: String,
    modifiedByUser: String,
    purchaseOrderHeaderId: String,
    purchaseOrderLineId: String,
    status: String,
    vendorLPN: String,
    advanceShippingNoticeId: String,
    advanceShippingNoticeLineId: String,
});

withDefaultSearchParamsMetadata<ReceiptLineSearchParams>(symbols.searchParams, {
    receiptId: String,
    vendorLPN: String,
    externalReferenceId: String,
});

export const ReceiptLineMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<ReceiptLineRead, ReceiptLineDto>(
            mapper,
            symbols.entity,
            symbols.dto
        );
        createMap<ReceiptLineDto, ReceiptLineRead>(
            mapper,
            symbols.dto,
            symbols.entity
        );
        createMap<ReceiptLineDto, ReceiptLineCreate>(
            mapper,
            symbols.dto,
            symbols.createBody,
            forMember(
                d => d.purchaseOrderHeaderId,
                mapFrom(s => s.purchaseOrderHeader?.id)
            ),
            forMember(
                d => d.purchaseOrderLineId,
                mapFrom(s => s.purchaseOrderLine?.id)
            )
        );
        createMap<IQueryParams<ReceiptLineDto>, ReceiptLineSearchParams>(
            mapper,
            IQueryParamsSymbol,
            symbols.searchParams,
            withSearchFilter('vendorLPN'),
            withSearchFilter('externalReferenceId')
            // TODO not working because of required parentId
            // ...withDefaultSearchParamsMappingConfiguration()
        );
    },
};
